export enum TABS {
  SURVEYS = 'Surveys',
  WHEELS = 'Wheels',
  INVENTORIES = 'Asset Inventories',
  DIAGNOSTICS = 'Diagnostics',
};
